import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Container } from '@material-ui/core';

import CardPerfil from './Empresa/CardPerfil';
import ListaVagas from './Empresa/ListaVagas';
import VagasAbertas from './Empresa/VagasAbertas';
import TotalCandidatos from './Empresa/TotalCandidatos';

import { getOpportunityCompany } from '../../../serviceAPI/opportunity/getOpportunityCompany'
import { getPerfilUsuario } from '../../../serviceAPI/user'
import { getAddress } from '../../../serviceAPI/getAddress'
import { getPhotoProfile } from '../../../serviceAPI/fotoPerfil/getPhotoProfile';

export default function DashEmpresa() {
  const dispatch = useDispatch();

  const vagas = useSelector(state => state.opportunity.opportunities)
  const fotoPerfil = useSelector(state => state.fotoPerfil)

  React.useEffect(() => {
    getOpportunityCompany(dispatch);
  }, []);

  const perfilUser = useSelector(state => state.user.user)

  React.useEffect(() => {
    getPerfilUsuario(dispatch);
  }, []);

  const userAddress = useSelector(state => state.endereco)

  React.useEffect(() => {
    getAddress(dispatch);
    getPhotoProfile(dispatch);
  }, []);

  const detalhesPerfil = {
    'fotoCapa': 'https://cdn.discordapp.com/attachments/768449017867796521/771071766490644500/capa_linkedin_iti.jpg',
    'fotoPerfil': fotoPerfil.uri,
    'nomeEmpresa': perfilUser ? `${perfilUser.first_name} ${perfilUser.last_name}` : "",
    'setorEmpresa': 'Setor',
    'cidadeEmpresa': userAddress ? `${userAddress.localidade}` : "",
    'ufEmpresa': userAddress ? `${userAddress.uf}` : "",
    'descricaoEmpresa': 'O ITI é um instituto sem fins lucrativos de pesquisa e fomento de tecnologias que, por meio de soluções tecnológicas, contribui e promove o desenvolvimento econômico, científico e social, levando a inclusão digital e social. Como entidade autossustentável, o ITI obtém recursos pela venda de projetos, pesquisa e desenvolvimento, bem como outros serviços tecnológicos de cunho social.É responsável por todas as suas despesas com recursos humanos, instalações e demais custos necessários para sua operação, não estando vinculado financeiramente a nenhuma empresa privada, nem órgão ou empresa pública. Foi certificado, no ano 2004, pelo Ministério da Justiça, através da Lei 9.790, como O.S.C.I.P.(Organização da Sociedade Civil de Interesse Público), que lhe permite, dentre outros desenvolvimentos, o de parceria com o setor público através da dispensa de processo licitatório. Com perfil multidisciplinar, o ITI trabalha de forma integrada com o setor empresarial, promovendo o desenvolvimento de pesquisas nas diversas áreas da tecnologia.Realiza consultoria tecnológica, serviços técnicos especializados, certificação de produtos e atua na formação e capacitação profissional, através de programas de educação continuada e treinamentos; programas de aprendizagem e de pessoas com deficiência.',
  }

  let detalhesListaVagas = [];

  vagas.map(vaga => {
    if (vaga.subscriptions) {
      const qtdSubs = vaga.subscriptions[0] === null ? 0 : vaga.subscriptions.length;
      detalhesListaVagas.push({ 'vaga': vaga.title, 'qtd_candidatos': qtdSubs });
    }
  });

  const detalhesVagasAbertas = detalhesListaVagas.length;

  return (
    <div style={{ paddingTop: 20 }}>
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} >
            <CardPerfil detalhesPerfil={detalhesPerfil} />
          </Grid>
          <Grid item xs={12} md={4}>
            <ListaVagas detalhesListaVagas={detalhesListaVagas} />
          </Grid>
          <Grid item xs={12} md={2}>
            <VagasAbertas detalhesVagasAbertas={detalhesVagasAbertas} />
            <TotalCandidatos detalhesTotalCandidatos={detalhesListaVagas} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}